@if (isStickyVisible) {
  <app-section-template [isSticky]="true" [hasPadding]="false">
    <app-select-category
      [noPadding]="true">
    </app-select-category>
  </app-section-template>
}

<app-three-column-template
  [hasCustomMain]="true"
  [hasCustomTitle]="true"
  [pageData]="pageData()"
  [showTags]="false">

  <app-side-navigation
    [addTags]="true"
    [pageData]="pageData()" slot="left-section"></app-side-navigation>

  <app-breadcrumbs [pageData]="pageData()" slot="breadcrumb-section"></app-breadcrumbs>

  <app-select-category
    slot="above-title">
  </app-select-category>

  <div class="item-title">{{ pageData()?.title }}</div>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  @if (pageData() && (!pageData().items || !pageData().items?.items?.length)) {
    <app-ck-viewer
      [fullBody]="true"
      [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>
  }


  @if (pageData() && HELPER.FF.collections) {
    <app-collections [pageData]="pageData()"/>
  }

  @if (pageData() && pageData().items) {
    <app-latest-news-section
      [showTitle]="false"
      [data]="pageData().items.items || []"
      [showSeeAllButton]="false"
    ></app-latest-news-section>
  }

  @if (pageData() && pageData().items) {
    <app-paginator
      [totalRecords]="pageData().items.totalCount"
      slot="pagination"/>
  }



  <ng-container slot="right-section">

    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>

  </ng-container>

</app-three-column-template>
